<template>
	<footer>
		<div class="ho-co-bottom">
			<div class="container-fluid hc-bo-main pl-0 pr-0 container500">
				<div class="auto">
					<ul class="hc-bo-list">
						<li :class = "{'active': $route.path.includes('/orders')}">
							<router-link class="hc-bo-set" :to = "'/' + $route.params.businessID + '/orders'">
								{{copywriting[language]['Orders']}}
							</router-link>
						</li>
						<li :class = "{'active': $route.path.includes('/manager')}">
							<router-link class="hc-bo-set" :to = "'/' + $route.params.businessID + '/manager'">
								{{copywriting[language]['Store']}}
							</router-link>
						</li>
						<li :class = "{'active': $route.path.includes('/products') && !$route.path.includes('/manager')}">
							<router-link class="hc-bo-set" :to = "'/' + $route.params.businessID + '/products'">
								{{copywriting[language]['Product']}}
							</router-link>
						</li> 
						<li :class = "{'active': $route.path.includes('/what-is-new')}" @click = "updateAdTime">
							<router-link class="hc-bo-set relative" :to = "'/' + $route.params.businessID + '/what-is-new'">
								{{copywriting[language]["What's New"]}}
								<div class="new" v-if = "savedTime < merchantAds['Date Updated']"></div>
							</router-link>
						</li> 
						<li :class = "{'active': $route.path.includes('/profile-manager/update-password')}">
							<router-link class="hc-bo-set" :to = "'/' + $route.params.businessID + '/profile-manager/update-password'">
								{{copywriting[language]['Setting']}}
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</footer>
</template>
<script>
var bID;
export default {
  //=========================================================//
  //                                                         //
  //                            DATA                         //
  //                                                         //
  //=========================================================//
  data(){
  	this.$store.commit("loadState", this.$route.params.businessID);
  	return{
  		merchantAds: this.$parent.merchantAds,
  		savedTime: this.$store.getters.getAdTime(),
  		copywriting: copywriting,
  		language: this.$store.getters.getLanguage()
  	}
  },


  //=========================================================//
  //                                                         //
  //                            WATCH                        //
  //                                                         //
  //=========================================================//
  watch:{
  	"$parent.merchantAds"(){
  		this.merchantAds = this.$parent.merchantAds;
  	}
  },



  //=========================================================//
  //                                                         //
  //                            METHODS                      //
  //                                                         //
  //=========================================================//
  methods: {
  	updateAdTime(){
  		this.$store.commit("updateAdTime", {time: this.merchantAds["Date Updated"], bID: this.$route.params.businessID});
  		this.$store.commit("loadState", this.$route.params.businessID);
  		this.savedTime = this.$store.getters.getAdTime();
  	}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FooterNav.vue